<div [class.component-main]="!embedded" [class.embedded]="embedded" [hidden]="isEmbeddedPageOpen">
    <div class="content-space-between">
        <h1>{{ 'regions' | myLbTranslate }}</h1>
        <button
            id="region-add-region"
            class="primary"
            [disabled]="!permissionsLookup['add-region']"
            (click)="addRegion()">{{ 'region_add' | myLbTranslate }}
        </button>
    </div>
    <app-table
        id="regions"
        [showPaginator]="true"
        [data]="tableRows"
        [stickyHeader]="true"
        [componentEmbedded]="embedded"
        [selectedRows]="selectedRowObject"
        [multiSelectActions]="!embedded ? multiSelectActions : []"
        (selectedRowsOut)="onSelect($event)">
        <app-column [flexGrow]="0.5" prop="name" label="name" [cellTemplate]="nameTemplate">
            <ng-template let-data #nameTemplate>
                <button
                    id="region-link-{{data.name}}"
                    class="routerLink"
                    [disabled]="!permissionsLookup['region-link']"
                    (click)="goToRegion(data)">{{ data.name }}
                </button>
            </ng-template>
        </app-column>
        <app-column [flexGrow]="0.5" prop="count" label="count"></app-column>
        <app-column [flexGrow]="0.3" prop="usage" label="usage"></app-column>
        <app-column
            prop="actions"
            label=""
            [cellTemplate]="actionsTemplate">
            <ng-template let-data #actionsTemplate>
                <div>
                    <app-action-dots>
                        <button
                            id="regions-view-subnets-{{data.name}}"
                            [disabled]="!permissionsLookup['region-link'] || data.count === 0"
                            appHint
                            hintPosition="left"
                            [hintText]="data.count === 0 ? ('region_no_subnets_hint' | myLbTranslate) : ''"
                            (click)="viewSubnets(data.id)">
                            {{ 'region_view_subnets' | myLbTranslate }}
                        </button>
                        <button
                            id="regions-edit-region-{{data.name}}"
                            [disabled]="!permissionsLookup['edit-region']"
                            (click)="editRegion(data)">
                            {{ 'edit' | myLbTranslate }}
                        </button>
                        <button
                            id="regions-delete-region-{{data.name}}"
                            [disabled]="!permissionsLookup['delete-region']"
                            (click)="confirmDeleteRegion(data)">
                            {{ 'delete' | myLbTranslate }}
                        </button>
                    </app-action-dots>
                </div>
            </ng-template>
        </app-column>
    </app-table>
</div>

<app-modal-wrapper [translateText]="false" [modalTitle]="'Subnet(s) - ' + regionData?.name" modalId="subnet-list">
    <app-modal-body>
        <ng-container *ngFor="let subnet of regionData?.subnets">
            <div class="subnet-container" [class.shimmer]="shimmer">
                {{ subnet }}
                <button appCopyClipboard class="copy-icon" [textToCopy]="subnet" (click)="copySubnet()"></button>
            </div>
        </ng-container>
    </app-modal-body>
</app-modal-wrapper>

<ng-container #embeddedComponentContainer></ng-container>

<app-modal-wrapper
    modalTitle="region_deleting_regions"
    modalId="regions-delete-progress"
    modalWidth="450"
    [isOverlayClickable]="false"
    [showCloseButton]="false">
    <app-modal-body>
        <div class="progress-container">
            <div class="loader"></div>
            <div class="progress-box" [innerHTML]=progressMessage></div>
        </div>
    </app-modal-body>
</app-modal-wrapper>
